import { Link } from "react-router-dom";
import { FAQ } from "../content/faq";

export function HowItWorks() {
  return (
    <section className="panel legal">
      <h2>How LimeShare works</h2>
      <p className="hint">End-to-end encrypted file transfer without accounts, explained step by step.</p>

      <h3>1. You pick files</h3>
      <p>
        Drop up to 3 files (3 GB each) into the page. Nothing is uploaded yet. Your browser generates a random 256-bit master key
        and derives separate keys for each file and for the metadata using HKDF.
      </p>

      <h3>2. Your browser encrypts</h3>
      <p>
        Each file is read as a stream and encrypted in 4 MiB frames with AES-256-GCM (the open LSC1 container format). The frame
        counter and a "last frame" flag are part of the nonce, and the header carrying the exact file length is authenticated —
        so a truncated, reordered or altered download is detected before any plaintext is released. File names, sizes, types and
        your message are encrypted into a separate manifest.
      </p>

      <h3>3. Ciphertext goes straight to storage</h3>
      <p>
        Encrypted bytes are uploaded in parallel parts directly from your browser to object storage using short-lived signed URLs.
        Our servers only coordinate: they never see, proxy or scan the bytes. When the upload finishes, the server checks that the
        stored object is exactly the declared length — to the byte — before the transfer becomes active.
      </p>

      <h3>4. You share a link</h3>
      <p>
        The link looks like <code>limeshare.org/d/ID#key.token</code>. Everything after <code>#</code> is the URL fragment, which
        browsers never send to any server. It holds the decryption key and an access token; we store only a SHA-256 hash of the
        token. Optionally the key is additionally wrapped with a password (Argon2id), and you can show the link as a QR code.
      </p>

      <h3>5. The recipient decrypts locally</h3>
      <p>
        The recipient's browser presents the token, receives the encrypted manifest and signed download URLs, downloads the
        ciphertext from storage, verifies every frame and writes the decrypted file to disk as a stream — even for multi-gigabyte
        files. Nothing is installed.
      </p>

      <h3>6. Everything disappears</h3>
      <p>
        Transfers are deleted precisely at expiry (48 hours by default, or 1/6/24 hours if you choose), immediately after the
        first download with "burn", or whenever you press Destroy. Storage-level lifecycle rules act as a second safety net,
        and metadata rows are purged from the database afterwards.
      </p>

      <p className="hint" style={{ marginTop: 22 }}>
        Details: <Link to="/security">security model</Link> · <Link to="/faq">FAQ</Link> · <Link to="/">send files now</Link>
      </p>
    </section>
  );
}

export function Faq() {
  return (
    <section className="panel legal">
      <h2>Frequently asked questions</h2>
      {FAQ.map((item) => (
        <div key={item.q}>
          <h3>{item.q}</h3>
          <p>{item.a}</p>
        </div>
      ))}
      <p className="hint" style={{ marginTop: 22 }}>
        <Link to="/how-it-works">How it works</Link> · <Link to="/security">Security</Link> · <Link to="/">Send files</Link>
      </p>
    </section>
  );
}
